/* eslint-disable parog-web/no-glint-expect-error-directive */
import { concat } from '@ember/helper';
import { on } from '@ember/modifier';
import { LinkTo } from '@ember/routing';
import { service } from '@ember/service';
import Component from '@glimmer/component';
import can from 'ember-can/helpers/can';
import t from 'ember-intl/helpers/t';
import ProductName from 'parog-web/components/product-name';
import capitalize from 'parog-web/helpers/capitalize';
import type ParogService from 'parog-web/services/parog';
import type SemeiaSessionService from 'parog-web/services/session';
import { isProduction } from 'parog-web/utils/runtime-environment';
import fuiDropdown from 'wise-fui-modules/modifiers/fui-dropdown';
interface Signature {
  Args: {
    currentMedic?: unknown;
  };
}

export default class DropdownHeaderComponent extends Component<Signature> {
  @service declare parog: ParogService;
  @service declare session: SemeiaSessionService;

  get isProduction() {
    return isProduction();
  }

  get isToucanEnabled(): boolean {
    return Boolean(
      this.session.medic?.healthCentres?.some(
        healthCentre => healthCentre.toucanEnabled
      )
    );
  }

  toggleWiser = () => {
    this.parog.isWiserEnabled = !this.parog.isWiserEnabled;
  };

  <template>
    <div
      {{fuiDropdown}}
      data-test-header-dropdown-menu
      class='ui dropdown floating item hover:![background:none] [&.active]:![background:none]'
    >
      <i class='large user md icon'></i>

      <div class='menu'>
        <div class='disabled item'>
          <i class='first aid icon'></i>
          Vous êtes&nbsp;:

          {{! @glint-expect-error }}
          {{@currentMedic.fullName}}
          •

          {{! @glint-expect-error }}
          {{capitalize (t (concat 'medic.role.' @currentMedic.role))}}
        </div>

        <LinkTo @route='medics-web.protected.profile' class='item'>
          <i class='large edit icon outline'></i>
          Éditer mon profil
        </LinkTo>

        <LinkTo @route='medics-web.protected.index.patient-list' class='item'>
          <i class='user md icon'></i>
          Liste des patients
        </LinkTo>

        {{#if (can 'list medic')}}
          <LinkTo @route='medics-web.protected.medics' class='item'>
            <i class='user md icon'></i>
            Liste des soignants
          </LinkTo>
        {{/if}}

        {{#if (can 'invoice health-centre')}}
          <LinkTo
            @route='medics-web.protected.health-centre-invoices'
            class='item'
          >
            <i class='file md icon'></i>
            Facturation de la télésurveillance
          </LinkTo>
        {{/if}}

        {{#if this.isToucanEnabled}}
          <LinkTo
            @route='medics-web.protected.toucan-dashboard'
            data-test-toucan-dashboard
            class='item'
          >
            <i class='chartline icon'></i>
            Statistiques
          </LinkTo>
        {{/if}}

        <LinkTo @route='view-terms-of-use' data-test-terms-of-use class='item'>
          <i class='info icon'></i>
          Informations légales
        </LinkTo>

        <LinkTo @route='medics-web.protected.help' class='item'>
          <i class='question circle icon'></i>
          Aide
        </LinkTo>

        <a data-test-logout-button class='item' href={{this.session.logoutUrl}}>
          <i class='large sign out icon'></i>
          Se déconnecter de
          <ProductName />
        </a>

        {{#unless this.isProduction}}
          <button {{on 'click' this.toggleWiser}} class='item' type='button'>
            {{if this.parog.isWiserEnabled 'Désactiver Wiser' 'Activer Wiser'}}
          </button>
        {{/unless}}
      </div>
    </div>
  </template>
}
